<template>
	<!-- <Header></Header> -->
	<div style="font-size: 22px;color: #000000;">手机端正在维护中，请使用PC端进行浏览</div>
</template>

<script>
import Header from '@/components/Header'
export default{
	name:"load",
	components:{
		Header
	}
}
</script>

<style>
</style>